export default {
  courses_page: 'darkOrange',
  course: 'darkOrange',
  serious_games_page: 'blue',
  serious_game: 'blue',
  events_page: 'yellow',
  event: 'yellow',
  pain_finder_page: 'blue',
}
